import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
declare const bootstrap: any; // Declare bootstrap globally

@Component({
  selector: 'app-category-modal',
  templateUrl: './category-modal.component.html',
  styleUrls: ['./category-modal.component.scss']
})
export class CategoryModalComponent {
  @Input() title: string = 'Create Category'; // Title of the modal
  @Input() category: { name: string; nameAr: string, id: number } = {
    name: '',
    nameAr: '',
    id: -1
  }; // Input object for category details
  @Output() onSave: EventEmitter<{ name: string; nameAr: string, id: number }> =
    new EventEmitter();
   
  @ViewChild('categoryModal') modalElement!: ElementRef;
  @ViewChild('categoryForm') categoryForm: any; // Reference the form

  ngOnChanges(changes: SimpleChanges) {
    // Reset the form whenever @Input properties change
    if (changes['category'] && this.categoryForm && this.category.id == -1) {
      this.categoryForm.resetForm(this.category); // Reset form with the updated category
    }
  }
  
  save(categoryForm: any) {
    // Check if the form is valid
    if (categoryForm.invalid) {
      // Mark all fields as touched to show validation errors
      Object.values(categoryForm.controls).forEach((control: any) => {
        control.markAsTouched();
      });
      return;
    }

    // Emit the updated category
    this.onSave.emit(this.category);

    // Close the modal programmatically
    const modalInstance = bootstrap.Modal.getInstance(this.modalElement.nativeElement);
    modalInstance.hide();
  }
  
}